import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { StorageService } from 'src/app/core/services/storage/storage.service';
import { UserModel } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class AppData {
  static outletNameClear = new BehaviorSubject(null);
  static token = new BehaviorSubject(null);
  static accountData = new BehaviorSubject(null);
  static promoSecUpdate = new BehaviorSubject(null);
  static baseUrl = environment.baseUrl;
  static manualBaseUrl = environment.manualBaseUrl;
  static suppportUrl = environment.suppportUrl;
  static reportUrl = environment.reportUrl;
  static addMenuitem = environment.addMenuitem;
  static outletList = [];
  static outletId = '';
  // static kshetraUrl = environment.kshetraUrl;
  static visitPlannerUrl = environment.visitPlannerUrl;
  static couponUrl = environment.couponUrl
  static imageUrl = environment.imageUrl;
  static outletMappingUrl = environment.Url;
  static viewPromoData = new BehaviorSubject(null);
  static outletValidation = environment.outletValidation;
  static individualRestaurantInfo = new BehaviorSubject(null);
  static updatedKshetraClear = new BehaviorSubject(null);
  static isAuthenticated = false;
  static userDataSubject = new BehaviorSubject(null);
  static userData: UserModel;
  static citys = new BehaviorSubject(null);
  // below will be used for checking if we have to change pointer of side menu
  static appPermissionCheck = new BehaviorSubject('init');

  static deliveryPartnerSub$ = new BehaviorSubject(null);

  constructor(private storage: StorageService) {
    if (this.storage.getItem('token') !== null) {
      AppData.token.next(this.storage.getItem('token'));
      AppData.isAuthenticated = true;
    }

    if (this.storage.getItem('userData') !== null) {
      AppData.userDataSubject.next(this.storage.getItem('userData'));
    }

    AppData.token.subscribe((data: string) => {
      this.setToken(data);
    });

    AppData.userDataSubject.subscribe((userData) => {
      this.storage.setItem('userData', userData);
      AppData.userData = Object.assign(new UserModel, userData);
    });
  }

  setToken(token: string) {
    this.storage.setItem('token', token);
  }

  isAuthenticatedFunction() {
    return !(this.storage.getItem('token') === null);
  }

}
